/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from '../Spinner';
import styles from './styles.module.scss';

type Props = {
  noScroll?: boolean;
};

const ProgressModal: React.FC<Props> = ({ noScroll }) => {
  const [show, setShow] = useState(false);
  const noScrollRef = useRef(noScroll);

  useEffect(() => {
    noScrollRef.current = noScroll;
  }, [noScroll]);

  useEffect(() => {
    setShow(true);
  }, []);

  useEffect(() => {
    return () => {
      const documentElementStyle = document.documentElement ? document.documentElement.style : {};
      const scrollOptionsSupported = 'scrollBehavior' in documentElementStyle;

      if (!noScrollRef.current && scrollOptionsSupported) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else if (!noScrollRef.current) {
        window.scrollTo(0, 0);
      }
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <React.Fragment>
      <Spinner className={styles.modalSpinner} dataTestId="progressModal" />
      <span className={styles.dialog} />
    </React.Fragment>
  );
};

export default ProgressModal;
